import HttpClient from '@src/shared/services/base/http-client';
import MCPMarketEnvironmentDetection, {
  MCP_MARKET_ENVIRONMENT_COUNTRY_CODES,
} from '@src/shared/utils/market-environment-detection';

export type TShowUnassignedOrdersResponse = {
  result: String;
};

export interface IShowUnassignedOrders {
  courierId: string;
  isEnabled: Boolean;
  restaurantId: string;
}
export type TShowUnassignedOrders = (
  showUnassignedOrderVariables: IShowUnassignedOrders
) => Promise<String>;

class ResturantSettingsApiService extends HttpClient {
  constructor(baseURL: string, authHeaderName: string) {
    super(baseURL, authHeaderName);
  }

  public showUnassignedOrders: TShowUnassignedOrders = ({ courierId, isEnabled, restaurantId }) => {
    return this.instance.put(`${restaurantId}/settings/show-unassigned-orders`, {
      courierId,
      isEnabled,
    });
  };
}

const getBaseUrl = () => {
  const { countryCode } = MCPMarketEnvironmentDetection.getMarketEnvironment();
  if (countryCode === MCP_MARKET_ENVIRONMENT_COUNTRY_CODES.UK) {
    return process.env.RESTAURANT_SETTINGS_API_NEW_URL_EU_WEST as string;
  }
  return process.env.RESTAURANT_SETTINGS_API_NEW_URL_EU_CENTRAL as string;
};

export default new ResturantSettingsApiService(getBaseUrl(), 'X-Auth');
